import { Component, Input, model } from '@angular/core';

@Component({
    selector: 'c-textarea',
    templateUrl: './textarea.component.html',
    styleUrl: './textarea.component.css',
    standalone: false
})
export class TextareaComponent {
  trim() {
    this.valor.set(this.valor().trim());
  }

  valor = model<string>('');

  @Input() placeholder: string = 'Inserte placeholder';

  @Input() etiqueta: string = 'Inserte etiqueta';

  @Input() readonly: boolean = false;

  @Input() alto: string = '';
  @Input() rows: number | undefined;

  /** Aplica animaciones */
  show = false;

  /** Permite linkear una variable bool, para mostrar los mensajes de error */
  @Input() showError = false;
  /** Definimos un mensaje de error para mostrar */
  @Input() mensajeError = '';
}
